import { createContext } from 'react';

const authContext = createContext({});

export const AuthProvider = authContext.Provider;
export const AuthConsumer = authContext.Consumer;
export default authContext;
